module.exports = __webpack_public_path__ + "static/media/Pets.01d15aaa.svg";